import React, { type ComponentType } from 'react';
import { useIsFocused } from '@react-navigation/native';
import { StyleSheet, View } from 'react-native';

import { colors } from '../../../core/theme/tokens';

/**
 * Web bottom-tabs keep visited screens mounted (no unmountOnBlur).
 * Wrap each tab so inactive routes render nothing — stops widget bleed
 * through glass and drops GPU work from off-screen charts.
 */
export function webOnlyFocusedTab<P extends object>(Screen: ComponentType<P>): ComponentType<P> {
  function FocusedTabScreen(props: P) {
    const focused = useIsFocused();
    if (!focused) {
      return <View style={styles.placeholder} />;
    }
    return <Screen {...props} />;
  }

  const name = Screen.displayName || Screen.name || 'Screen';
  FocusedTabScreen.displayName = `WebFocused(${name})`;
  return FocusedTabScreen as ComponentType<P>;
}

const styles = StyleSheet.create({
  placeholder: {
    flex: 1,
    backgroundColor: colors.background,
  },
});
